export default "__VITE_ASSET__ttc7MbJT__"